var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helpCenter",on:{"click":_vm.showHelp}},[_vm._v(" 帮助引导 ")])}
var staticRenderFns = []

export { render, staticRenderFns }